import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./../styles/transaction.css";
import AccountLayout from "../layouts/AccountLayout";
import { HashLoader } from "react-spinners";
import showToast from "../components/toasts/ToastNotification";
import {
  productTypeText,
  statusClass,
  statusText,
} from "../utils";
import { getAllOrders } from "../api/order.api";
import { FaEye } from "react-icons/fa6";
import Pagination from "../components/pagination/Pagination";

const ITEMS_PER_PAGE = 8;

const Order = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        const res = await getAllOrders(100);
        if (res.success) {
          setOrders(res.data.orders || []);
        }
      } catch (error) {
        showToast(error.message, "error");
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  const totalPages = Math.ceil(orders.length / ITEMS_PER_PAGE);
  const currentOrders = orders.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );
  const successOrders = orders.filter((o) => o.order_status === "success").length;
  const processingOrders = orders.filter((o) => o.order_status === "processing").length;
  const failedOrders = orders.filter((o) => o.order_status === "failed").length;

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return (
    <AccountLayout title={"Đơn hàng"}>
      <div className="transaction-container">
        <div className="transaction-page-head">
          <h3 className="transaction-title">Đơn hàng của bạn</h3>
          <p className="transaction-subtitle">Theo dõi trạng thái xử lý của toàn bộ đơn hàng đã mua.</p>
        </div>

        <div className="transaction-kpi-grid">
          <div className="transaction-kpi-card">
            <p className="kpi-label">Hoàn thành</p>
            <p className="kpi-value success-status">{successOrders}</p>
          </div>
          <div className="transaction-kpi-card">
            <p className="kpi-label">Đang xử lý</p>
            <p className="kpi-value pending-status">{processingOrders}</p>
          </div>
          <div className="transaction-kpi-card">
            <p className="kpi-label">Đã hủy</p>
            <p className="kpi-value failed-status">{failedOrders}</p>
          </div>
        </div>

        {loading ? (
          <div className="loader-container">
            <HashLoader color="var(--hash-loader-color)" size={30} />
          </div>
        ) : (
          <>
            <div className="transaction-table-shell">
              <table className="transaction-table">
                <thead>
                  <tr>
                    <th>STT</th>
                    <th>Mã đơn hàng</th>
                    <th>Số tiền</th>
                    <th>Loại</th>
                    <th>Trạng thái</th>
                    <th>Nội dung</th>
                    <th>Thời gian</th>
                    <th>Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  {currentOrders.length > 0 ? (
                    currentOrders.map((tx, index) => (
                      <tr key={tx.orderId}>
                        <td>{index + 1}</td>
                        <td>{tx.orderId}</td>
                        <td>
                          <span className="amount-pill amount-pill-primary">
                            {tx.order_final_amount.toLocaleString() || 0}đ
                          </span>
                        </td>
                        <td>{productTypeText(tx.order_type)}</td>
                        <td className="transaction-status-cell">
                          <span className={`status-badge ${statusClass(tx.order_status)} transaction-status`}>
                            {statusText(tx.order_status)}
                          </span>
                        </td>
                        <td>{tx.note}</td>
                        <td>{new Date(tx.createdAt).toLocaleString()}</td>
                        <td>
                          <button
                            className="action-button"
                            onClick={() => navigate(`/order/${tx.orderId}`)}
                          >
                            <FaEye className="action-icon" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="table-empty-cell">Không có đơn hàng nào</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPrev={handlePrevPage}
                onNext={handleNextPage}
              />
            )}
          </>
        )}
      </div>
    </AccountLayout>
  );
};

export default Order;
